import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Mon Jan 13 2019
 * @author PKr
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
import { List } from 'immutable';
import { Inject } from '@logio/typescript-ioc';
import { jsonConversions, PromotionConverter, ReplenishmentPromoManagementReportConverter, ReplenishmentPromoManagementRowDTOConverter, ReplePromoManagementDetailFilterConverter, ResultWithOverviewConverterImpl, OverviewConverterImpl, Overview, Pagination, ReplenishmentPromoManagementUpdateDTOConverter, ReplenishmentPromoManagementUpdateResultConverter } from '@logio/common-be-fe';
/**
 * Replenishment Promotion Management layer
 */

export var ReplePromoManagementLayer =
/*#__PURE__*/
function () {
  function ReplePromoManagementLayer() {
    _classCallCheck(this, ReplePromoManagementLayer);

    this.replePromoManagementReportConverter = new ReplenishmentPromoManagementReportConverter();
  }
  /**
   * Gets filtered {@link Promotion} entities based on provided filter
   *
   * @param filter
   */


  _createClass(ReplePromoManagementLayer, [{
    key: "filterPromotions",
    value: function filterPromotions(filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", api(CONSTANTS.API.ENDPOINTS.REPLE_PROMO_MANAGEMENT_FILTER_PROMOTIONS).post(filter, {
                  responseType: 'json'
                }).then(function (response) {
                  return List((response.data.result || []).map(function (i) {
                    return _this.promotionConverter.toObject(i, jsonConversions);
                  }));
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
    /**
     * Generates report for replenishment promotion management report
     *
     * @param promotionIds
     * @param categoryIds
     * @returns Promise<CreatePromotionSetResult>
     */

  }, {
    key: "generateReport",
    value: function generateReport(promotionIds, categoryIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var params;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  promotionIds: promotionIds.toArray(),
                  categoryIds: categoryIds.toArray()
                };
                return _context2.abrupt("return", api(CONSTANTS.API.ENDPOINTS.REPLE_PROMO_MANAGEMENT_REPORT_GENERATE).post(params, {
                  responseType: 'json'
                }).then(function (response) {
                  return _this2.replePromoManagementReportConverter.toObject(response.data.result, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
    /**
     * Gets {@link ReplenishmentPromoManagementReport} object information
     *
     * @param reportId
     * @returns Promise<ReplenishmentPromoManagementReport>
     */

  }, {
    key: "report",
    value: function report(reportId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", api(CONSTANTS.API.ENDPOINTS.REPLE_PROMO_MANAGEMENT_REPORT(reportId)).get({
                  responseType: 'json'
                }).then(function (response) {
                  return _this3.replePromoManagementReportConverter.toObject(response.data.result, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
    /**
     * Gets rows for replenishment promotion management report
     *
     * @param reportId
     * @param filter
     * @param limit
     * @param offset
     * @returns Promise<ResultWithOverview<ReplenishmentPromoManagementRowDTO, ReplePromoManagementDetailFilter>>
     */

  }, {
    key: "reportNodes",
    value: function reportNodes(reportId, filter, limit, offset) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var overviewConverter, resultWithOverviewConverter, pagination, overview;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                /** Get dependent converters */
                overviewConverter = new OverviewConverterImpl(this.replePromoManagementDetailFilterConverter);
                resultWithOverviewConverter = new ResultWithOverviewConverterImpl(this.replePromoManagementRowDTOConverter, this.replePromoManagementDetailFilterConverter);
                /** Get dependent overview */

                pagination = new Pagination(limit, offset, null);
                overview = new Overview(filter, null, null, pagination);
                return _context4.abrupt("return", api(CONSTANTS.API.ENDPOINTS.REPLE_PROMO_MANAGEMENT_REPORT_NODES(reportId)).post({
                  overview: overviewConverter.toDocument(overview, jsonConversions)
                }, {
                  responseType: 'json'
                }).then(function (response) {
                  return resultWithOverviewConverter.toObject(response.data, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Updates row for replenishment promotion management report
     *
     * @param reportId
     * @param updates
     * @returns Promise<List<ReplenishmentPromoManagementRowDTO>>
     */

  }, {
    key: "reportNodesUpdate",
    value: function reportNodesUpdate(reportId, updates) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", api(CONSTANTS.API.ENDPOINTS.REPLE_PROMO_MANAGEMENT_REPORT_NODES_UPDATE(reportId)).post({
                  updates: updates.map(function (dtoList) {
                    return dtoList.map(function (dto) {
                      return _this4.replenishmentPromoManagementUpdateDTOConverter.toDocument(dto, jsonConversions);
                    });
                  })
                }, {
                  responseType: 'json'
                }).then(function (response) {
                  return _this4.replenishmentPromoManagementUpdateResultConverter.toObject(response.data.result, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    }
  }]);

  return ReplePromoManagementLayer;
}();

__decorate([Inject, __metadata("design:type", PromotionConverter)], ReplePromoManagementLayer.prototype, "promotionConverter", void 0);

__decorate([Inject, __metadata("design:type", ReplenishmentPromoManagementRowDTOConverter)], ReplePromoManagementLayer.prototype, "replePromoManagementRowDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", ReplePromoManagementDetailFilterConverter)], ReplePromoManagementLayer.prototype, "replePromoManagementDetailFilterConverter", void 0);

__decorate([Inject, __metadata("design:type", ReplenishmentPromoManagementUpdateDTOConverter)], ReplePromoManagementLayer.prototype, "replenishmentPromoManagementUpdateDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", ReplenishmentPromoManagementUpdateResultConverter)], ReplePromoManagementLayer.prototype, "replenishmentPromoManagementUpdateResultConverter", void 0);